import React from "react";
import { cn } from "@/lib/utils";

interface LinkButtonProps {
    onClick: () => void;
    children: React.ReactNode;
    title?: string;
    className?: string;
}

export default function LinkButton({ onClick, children, title, className }: Readonly<LinkButtonProps>) {
    return (
        <button
            type="button"
            onClick={onClick}
            title={title}
            className={cn("hover:underline cursor-pointer", className)}
        >
            {children}
        </button>
    );
}
